import { render, staticRenderFns } from "./KpiOverview.vue?vue&type=template&id=c97f6148&scoped=true&"
import script from "./KpiOverview.vue?vue&type=script&lang=js&"
export * from "./KpiOverview.vue?vue&type=script&lang=js&"
import style0 from "./KpiOverview.vue?vue&type=style&index=0&id=c97f6148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97f6148",
  null
  
)

export default component.exports